import { render, staticRenderFns } from "./notOnshelf.vue?vue&type=template&id=dfad1b48&scoped=true"
import script from "./notOnshelf.vue?vue&type=script&lang=js"
export * from "./notOnshelf.vue?vue&type=script&lang=js"
import style0 from "./notOnshelf.vue?vue&type=style&index=0&id=dfad1b48&prod&lang=css"
import style1 from "./notOnshelf.vue?vue&type=style&index=1&id=dfad1b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfad1b48",
  null
  
)

export default component.exports